import { Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { StyleEnum } from '../enums/style.enum';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  constructor(public platform: Platform) {
  }

  print(html: any, mode = StyleEnum.NONE): void {
    let style = '';
    switch (mode) {
    case StyleEnum.PRODUCTION_FILE:
      style = this.getProductionFileStyle();
      break;
    case StyleEnum.VISUALS:
      style = this.getVisualsStyle();
      break;
    case StyleEnum.ORDER_PRODUCTS:
      style = this.getOrderProductsStyle();
      break;
    }
    if (this.platform.IOS || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      const popup = window.open();
      popup.document.write(style + html);
      popup.document.close();
      setTimeout(() => {
        popup.focus();
        popup.print();
        popup.close();
      }, 1000);
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.name = 'frame1';
    document.body.appendChild(iframe);
    const frameDoc = iframe.contentWindow;
    frameDoc.document.open();
    frameDoc.document.write(style + html);
    frameDoc.document.close();

    if (this.platform.ANDROID) {
      setTimeout(() => {
        window.frames['frame1'].focus();
        window.frames['frame1'].print();
      }, 1000);

      setTimeout(() => {
        iframe.remove();
      }, 2000);
      return;
    }

    iframe.onload = (): void => {
      iframe.contentWindow.onafterprint = (): void => iframe.remove();
      iframe.contentWindow.document.body.innerHTML = style + html;
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };
  }

  private getVisualsStyle(): string {
    return `<style>
          @page {
            size: A4 portrait;
            margin: 0;
            padding: 0;
          }
          
          .page {
            height: 280mm;
            width: 209mm;
            font-family: arial, sans-serif;
            box-sizing: border-box;
            font-size: 12px;
            padding: 5mm;
            gap: 5mm;
          }
          
          img {
            height: calc(100% - 54mm);
            width: 100%;
            object-fit: scale-down;
            margin-bottom: 6px;
          }
          
          table {
            height: 50mm;
            width: 100%;
            border-collapse: collapse;
          }
          
          th, td {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 0 0 0 4px;
          }
          
          thead tr {
            height: 4mm;
            box-sizing: border-box;
          }
          
          tbody tr {
            box-sizing: border-box;
            vertical-align: top;
          }
          
          tfoot td {
            box-sizing: border-box;
            vertical-align: middle;
            text-align: center;
          }
          
          td > div {
            height: 16mm;
            overflow: clip;
            word-break: break-all;
          }
          
          </style>`;
  }

  private getProductionFileStyle(): string {
    return `<style>
         @page {
            size: A4 portrait;
            margin: 0;
            padding: 0;
          }
          
          html {
            height: 280mm;
            width: 209mm;
            font-family: 'Verdana', Arial, sans-serif;
            box-sizing: border-box;
            font-size: 12px;
            margin: 0;
            padding: 0;
          }
          
          body {
            width: 100%;
            box-sizing: border-box;
            padding: 5mm;
            margin: 0;
          }
          table {
            width: 100%;
            font-family: arial, sans-serif;
            border-collapse: collapse;
            table-layout: fixed;
          }
          
          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding-left: 8px;
          }
          
          td {
            height: 121px;
            vertical-align: top;
          }
          
          td img {
            height: 120px;
            width: 120px;
            object-fit: scale-down;
          }
     </style>`;
  }

  private getOrderProductsStyle(): string {
    return `<style>
         @page {
            size: A4 portrait;
            margin: 0;
            padding: 0;
          }
                 
          .page {
            height: 280mm;
            width: 209mm;
            font-family: arial, sans-serif;
            box-sizing: border-box;
            font-size: 12px;
            padding: 5mm;
            gap: 5mm;
          }
          
          section {
            padding-top: 100mm;
          }
          
          .label-container {
            margin-top: 100mm;
            padding-top: 10mm;
            padding-left: 20px;
            padding-right: 20px;
            border-top: 2px dotted #000; 
          }
          
          .title-container {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
          }
          
          .transaction-id {
            text-align: start;
          }
          
          .customer-name {
            text-align: end;
          }
          
          .details-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          
          h1 {
            width: 100%;
            font-size: 48px;
            text-align: center;
            margin-bottom: 32px;
          }
          
          h2 {
            width: 100%;
            font-size: 42px;
            text-align: center;
            font-weight: bold;
            white-space: normal;
            word-break: break-word; 
          }
          
          p {
            font-size: 24px;
            margin: 0 0 8px;
            padding-left: 80px;
            padding-right: 80px;
          }
     </style>`;
  }
}
